<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-10-08 22:55:43
 * @Description: 
--> 
<template>
  <div class="home">
    <AppSidebar />
    <router-view class="content" />
  </div>
</template>

<script>
import AppSidebar from "@/components/layout/AppSidebar.vue";
export default {
  name: "home",
  components: {
    AppSidebar,
  },
};
</script>

<style scoped lang="stylus">
.home
  display flex
  width 100%
  height 100%

.content
  // margin-left 170px
  margin-top 40px
  // position fixed
  width 100%
  height calc(100vh - 40px)
</style>

